import {
    array,
    boolean,
    literal,
    nullable,
    number,
    object,
    string,
    union,
} from "superstruct";

import InstagramDisplaySettingsSchema from "./InstagramDisplaySettingsSchema";

const InstagramGallerySchema = object({
    id: number(),
    title: string(),
    accounts: array(string()),
    hashTags: array(string()),
    hideBranding: boolean(),
    storiesAccount: nullable(string()),
    description: nullable(string()),
    displaySettings: array(InstagramDisplaySettingsSchema),
    showReviewsAndQuestionsOnProductView: boolean(),
    popupTheme: union([literal("light"), literal("dark")]),
});

export default InstagramGallerySchema;
